'use strict';

function fSliderInspire () {
    let oSlider = document.querySelector('.js-slider-inspire');
    let oTextblock = document.querySelector('.js-slider-inspire-textblock');
    let oNav = document.querySelector('.js-slider-inspire-nav');
    let oButtonPrev = document.querySelector('.js-slider-inspire-prev');
    let oButtonNext = document.querySelector('.js-slider-inspire-next');
    let oFlickity = new Flickity(oSlider, {
        cellAlign: 'left',
        draggable: true,
        contain: true,
        groupCells: 2,
        freeScroll: false,
        prevNextButtons: false,
        on: {
            ready: function () {
                oNav.style.display = 'block';

                oButtonPrev.addEventListener('click', function() {
                    oFlickity.previous();
                });

                oButtonNext.addEventListener('click', function() {
                    oFlickity.next();
                });
            },
            dragStart: function () {
                oSlider.style.pointerEvents = 'none';
            },
            dragEnd: function () {
                oSlider.style.pointerEvents = 'all';
            }
        }
    });
    let iCalculatedOpacity;

    function fPosToNeg (number) {
        return Math.abs(number);
    }

    function fAnimateTextblock () {
        if (window.innerWidth < 992) return;

        oTextblock.style.transitionDuration = '0s';
        iCalculatedOpacity = (2 / (fPosToNeg(oFlickity.dragX) / 100)) - 1;
        
        oTextblock.style.opacity = iCalculatedOpacity;

        if ((oFlickity.dragX / 2) > -100 && (oFlickity.dragX / 2) < 0) {
            oTextblock.style.transform = 'translateX(' + (oFlickity.dragX / 2) + 'px)';
        }
    }

    oFlickity.on('change', function (index) {
        if (window.innerWidth < 992) return;

        if (index > 0) {
            oTextblock.setAttribute('style', '');
            oTextblock.style.transitionDuration = '.4s';
            oTextblock.style.opacity = 0;
            oButtonPrev.style.opacity = 1;
        } else {
            oTextblock.style.transitionDuration = '1s';
            oTextblock.style.opacity = 1;
            oButtonPrev.style.opacity = 0;
        }
    });

    oFlickity.on('dragMove', fAnimateTextblock);
}